// extracted by mini-css-extract-plugin
module.exports = {"projectStyles":"styles_projectStyles__1yCoB","contentStyles":"styles_contentStyles__uT5BA","image":"styles_image__7uRJT"};